export const extractStatusDataWithReason = (description: string) => {
    const [statusChanged, updatedBy] = description.split('Reason');
    const statusName = statusChanged.split('Status updated to')[1].trim();
    const status = statusName.replace(/\s/g, '_').toUpperCase();
    const updatedByProvider = updatedBy?.trim();
    return { status, updatedByProvider };
};

export const extractStatusData = (description: string) => {
    const [statusChanged, updatedBy] = description.split('by');
    const statusName = statusChanged.split('Status updated to')[1].trim();
    const status = statusName.replace(/\s/g, '_').toUpperCase();
    const updatedByProvider = updatedBy?.trim();
    return { status, updatedByProvider };
};
